import React, { useState, useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgWorkAlt } from "react-icons/cg";
import { ImBlog } from "react-icons/im";
import {
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";
import { CgFileDocument } from "react-icons/cg";
import { SiGithub } from "react-icons/si";
import { BsSun, BsMoon } from "react-icons/bs";

interface NavBarProps {
  theme: "light" | "dark";
  toggleTheme: () => void;
}

const NavBar: React.FC<NavBarProps> = ({ theme, toggleTheme }) => {
  const [expand, updateExpanded] = useState<boolean>(false);
  const [navColour, updateNavbar] = useState<boolean>(false);

  useEffect(() => {
    const scrollHandler = () => {
      if (window.scrollY >= 20) {
        updateNavbar(true);
      } else {
        updateNavbar(false);
      }
    };

    window.addEventListener("scroll", scrollHandler);
    return () => window.removeEventListener("scroll", scrollHandler);
  }, []);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        <Navbar.Brand href="/" className="d-flex">
          <h1 className="logo">David Jiang</h1>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => updateExpanded(!expand)}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            <Nav.Item>
              <Nav.Link as={Link} to="/" onClick={() => updateExpanded(false)}>
                <span style={{ marginBottom: "2px", display: "inline-block" }}><AiOutlineHome /></span> Home
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/about" onClick={() => updateExpanded(false)}>
                <span style={{ marginBottom: "2px", display: "inline-block" }}><AiOutlineUser /></span> About
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/work" onClick={() => updateExpanded(false)}>
                <span style={{ marginBottom: "2px", display: "inline-block" }}><CgWorkAlt /></span> Works
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/project" onClick={() => updateExpanded(false)}>
                <span style={{ marginBottom: "2px", display: "inline-block" }}><AiOutlineFundProjectionScreen /></span> Projects
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/resume" onClick={() => updateExpanded(false)}>
                <span style={{ marginBottom: "2px", display: "inline-block" }}><CgFileDocument /></span> Resume
              </Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link as={Link} to="/blog" onClick={() => updateExpanded(false)}>
                <span style={{ marginBottom: "2px", display: "inline-block" }}><ImBlog /></span> Blog
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className="fork-btn">
              <div className="fork-btn-group">
                <Button
                  href="https://github.com/David200308"
                  target="_blank"
                  className="fork-btn-inner"
                >
                  Follow my GitHub <span style={{ marginBottom: "2px", marginLeft: "5px", display: "inline-block" }}><SiGithub /></span>
                </Button>
                <button
                  onClick={toggleTheme}
                  className="theme-toggle"
                  aria-label="Toggle dark/light mode"
                >
                  {theme === "light" ? <BsMoon /> : <BsSun />}
                </button>
              </div>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default NavBar;
